module.exports = __webpack_public_path__ + "static/media/sidebar_logo.08575b48.svg";